<template>
  <v-card outlined>
    <table-search @search="v => (search = v)" />
    <v-data-table
      class="mt-5"
      dense
      fixed-header
      :headers="headers"
      :items="users"
      item-key="id"
      :items-per-page="15"
      :sort-by="['updatedAt']"
      :sort-desc="[true]"
      no-data-text="No Users Found!"
      no-results-text="No Users Found!"
      :search="search"
      :loading="pending"
      loading-text="Loading... Please wait"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <row-actions :actions="{ edit: () => doEdit(item), delete: () => doDelete(item) }" />
      </template>
      <template v-slot:[`item.enabled`]="{ item }">
        <v-simple-checkbox
          @input="toggleUser(item)"
          :ripple="false"
          v-model="item.enabled"
          color="primary"
        />
      </template>
      <template v-slot:[`item.user`]="{ item }">
        {{ item.fullName }}
      </template>
      <template v-slot:[`item.role`]="{ item }">
        <strong class="text-capitalize">{{ item.role || '-' }}</strong>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        {{ item.createdAt | moment('YYYY/MM/DD') }}
      </template>
      <template v-slot:[`item.updatedAt`]="{ item }">
        {{ item.updatedAt | moment('YYYY/MM/DD hh:mm A') }}
      </template>
      <template v-slot:footer>
        <table-action :actions="{ add: () => toggleUserForm('create') }" />
      </template>
    </v-data-table>
    <user-form />
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import userHeaders from '@/models/user-headers';

import UserForm from '@/components/user/UserForm';

export default {
  name: 'Users',
  data() {
    return { search: '' };
  },
  computed: {
    ...mapState('user', ['users', 'pending']),
    headers: () => userHeaders
  },
  methods: {
    ...mapMutations('user', ['setUser', 'toggleUserForm']),
    ...mapMutations('confirm', ['confirm']),
    ...mapActions('user', ['deleteUser']),
    doEdit(user) {
      this.setUser(user);
      this.toggleUserForm('update');
    },
    doDelete(user) {
      this.confirm({
        message: 'Do you want to delete this user ?',
        iconColor: 'error',
        acceptAction: () => this.deleteUser(user)
      });
    }
  },
  components: { UserForm }
};
</script>

<style lang="scss" scoped>
.table_search {
  width: 50%;
  @media (min-width: 340px) and (max-width: 767px) {
    width: 60%;
  }
}
</style>
